function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

const csrftoken = document.querySelector('[name=csrfmiddlewaretoken]').value;

const button_states = {
    "default": {
        "text": "Kostenpflichtig beauftragen",
        "class": "btn-primary",
        "icon": "bi bi-cart-plus"
    },
    "loading": {
        "text": "Erzeuge LIS-Report...",
        "class": "btn-primary",
        "icon": "spinner-button"
    },
    "success": {
        "text": "LIS-Report herunterladen",
        "class": "btn-success",
        "icon": "bi bi-file-earmark-arrow-down"
    },
}

const btn = $("#button_order");
const order_token = btn.data("order");
const btn_icon = btn.find("i");
const btn_text = btn.find(".button__text");
const button_home = $('.btn-home');


const button_config = $('#button_config');

export default $(document).ready(e => {
    // populate button with default state
    btn_icon.addClass(button_states.default.icon);
    btn_text.text(button_states.default.text);
    btn.addClass(button_states.default.class);

})

btn.click(e => {
    e.preventDefault();

    console.log("order token: " + order_token);
    // hide config button
    button_config.addClass("d-none");


    // send order and poll status
    sendOrderAndPollStatus(order_token);
    swapButtonContentToSpinner();
})


function sendOrderAndPollStatus(order_token) {
    console.log("sending order and polling status");

    fetch("/order/process", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrftoken
        },
        body: JSON.stringify({
            order_token: order_token
        })
    })
        .then(response => response.json())
        .then(data => {
            console.log('parsed json: ', data);
            if (data.fulfillment_id) {
                poll_status(data.fulfillment_id);
            } else {
                console.log("something went wrong");
            }
        })
        .catch(error => {
            console.log(error);
        })
}

// function to swap the button content into button with a spinner
function swapButtonContentToSpinner() {
    btn_icon.addClass(button_states.loading.icon);
    btn_text.text(button_states.loading.text);
    btn.addClass(button_states.loading.class);
    btn.prop("disabled", true);
}

//disbable config button
function disableConfigButton() {
    button_config.prop("disabled", true);
}

// function to swap the button content into a download button with a link to the pdf
function swapButtonContentToDownload(fileid) {
    // replace event listener
    btn.off("click");
    btn.click(e => {
        e.preventDefault();
        window.location.href = `/download/${fileid}`;
    });

    btn_icon.removeClass().addClass(button_states.success.icon);
    btn_text.text(button_states.success.text);
    btn.addClass(button_states.success.class);
    btn.prop("disabled", false);
}


// Function to poll status
function poll_status(fulfillment_id) {
    const pollingInterval = 5000; // 5 seconds in milliseconds

    const poll = setInterval(() => {
        // Replace 'YOUR_STATUS_ENDPOINT' with the actual endpoint to check status
        fetch(`/order/fulfillment/status/${fulfillment_id}`, {
            method: 'GET', // or 'POST', depending on your API
            // Add any required headers
        })
            .then(response => response.json())
            .then(data => {
                console.log('Status:', data.status);
                // Check the status and handle it accordingly
                if (data.status === 'fulfilled') {
                    clearInterval(poll); // Stop polling when status is 'completed'
                    console.log('Order completed:', data.fileid);
                    // swap button content
                    swapButtonContentToDownload(data.fileid);
                    button_home.removeClass("d-none");
                } else if (data.status === 'created' || data.status === 'progress') {
                    console.log('Order is still pending...');
                } else {
                    console.error('Unknown status:', data.status);
                    clearInterval(poll); // Stop polling on unknown status
                }
            })
            .catch(error => {
                console.error('Error polling status:', error);
                clearInterval(poll); // Stop polling on error
            });
    }, pollingInterval);
}
